module.exports = __webpack_public_path__ + "static/media/Carrot.0dc4f95d.webp";